import { useEffect } from "react";
import { readPerfilLogado } from "../api/perfilResource";

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

/**
 * Ilha sem UI: empurra o userId pro dataLayer do GTM quando há login,
 * substituindo o snippet PHP do WordPress que só fazia o push quando o
 * user_login tinha 36 chars (o GUID da conta, hoje idContaAutoPapo).
 *
 * A fonte da verdade é a API (readPerfilLogado); como o resource é singleton de
 * módulo, esta ilha e a LoginIsland compartilham o mesmo fetch.
 */
export default function TagManagerIsland() {
  // Suspende até o fetch voltar; o <Suspense> (sem fallback) não renderiza nada.
  const perfil = readPerfilLogado();
  const userId = perfil?.idContaAutoPapo;

  useEffect(() => {
    // Mantém o guard do WP: só empurra GUID de conta (36 chars).
    if (!userId || userId.length !== 36) return;
    window.dataLayer = window.dataLayer || [];
    // O pageview do GTM já passou quando a ilha hidrata, então o push precisa de
    // event: sem o trigger "userIdReady" no painel, nenhuma tag reenvia o user_id.
    window.dataLayer.push({ event: "userIdReady", userId });
  }, [userId]);

  return null;
}
